import React from 'react'
import { FaInstagram, FaFacebook, FaLinkedin } from 'react-icons/fa'
import logo from '../../assets/images/logo_final/logo.png'

const Footer: React.FC = () => {
  return (
    <footer className='mt-24 border-t border-black/5 bg-[#FDDFCC] text-gray-900 overflow-hidden relative'>
      {/* Barre dégradée “signature” */}
      <div className='h-1 w-full bg-gradient-to-r from-[#f40000] via-[#f75000] to-[#ff9900]' />

      {/* Glow décoratif (subtil) */}
      <div
        className='pointer-events-none absolute -top-48 -left-32 h-96 w-96 rounded-full blur-3xl opacity-30'
        style={{ background: 'radial-gradient(circle at center, #f75000 0%, transparent 60%)' }}
      />
      <div
        className='pointer-events-none absolute -bottom-48 -right-32 h-96 w-96 rounded-full blur-3xl opacity-25'
        style={{ background: 'radial-gradient(circle at center, #f40000 0%, transparent 60%)' }}
      />

      <div className='mx-auto w-full max-w-6xl px-4 sm:px-6'>
        <div className='py-14'>
          {/* Liens */}
          <div className='grid gap-10 mt-12 sm:grid-cols-2 lg:grid-cols-12'>
            {/* Company / logo */}
            <div className='lg:col-span-4'>
              <a href='/' className='inline-flex items-center gap-3'>
                <img src={logo} alt='Voyo' className='h-10 w-auto' />
                <span className='sr-only'>Voyo</span>
              </a>

              <p className='mt-4 max-w-sm text-sm leading-6 text-gray-700'>
                Voyo vous aide à déléguer la visite d’un bien à louer, simplement et en toute
                confiance.
              </p>

              <div className='mt-5 flex flex-wrap items-center gap-3 text-sm text-gray-700'>
                <span className='inline-flex items-center rounded-full border border-black/10 bg-white/60 px-3 py-1'>
                  Société Voyo
                </span>
                <a
                  href='mailto:hello@voyo.fr'
                  className='inline-flex items-center rounded-full border border-black/10 bg-white/60 px-3 py-1 hover:bg-white/80 transition'
                >
                  hello@voyo.fr
                </a>
              </div>
            </div>

            {/* Product */}
            <div className='lg:col-span-2'>
              <p className='text-sm font-semibold tracking-wide text-gray-900'>Produit</p>
              <ul className='mt-4 space-y-3 text-sm text-gray-700'>
                <li>
                  <a className='hover:text-gray-900 transition' href='/programmation-visite'>
                    Rechercher un visiteur
                  </a>
                </li>
                <li>
                  <a className='hover:text-gray-900 transition' href='/fonctionnement-voyo'>
                    Fonctionnement
                  </a>
                </li>
                <li>
                  <a className='hover:text-gray-900 transition' href='/inscription-visiteur'>
                    Devenir visiteur
                  </a>
                </li>
                <li>
                  <a className='hover:text-gray-900 transition' href='/dashboard'>
                    Dashboard
                  </a>
                </li>
              </ul>
            </div>

            {/* Company */}
            <div className='lg:col-span-2'>
              <p className='text-sm font-semibold tracking-wide text-gray-900'>Entreprise</p>
              <ul className='mt-4 space-y-3 text-sm text-gray-700'>
                <li>
                  <a className='hover:text-gray-900 transition' href='/a-propos-de-nous'>
                    À propos
                  </a>
                </li>
                <li>
                  <a className='hover:text-gray-900 transition' href='/fonctionnement-voyo'>
                    Notre blog
                  </a>
                </li>
                <li>
                  <a className='hover:text-gray-900 transition' href='mailto:hello@voyo.fr'>
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            {/* Support */}
            <div className='lg:col-span-2'>
              <p className='text-sm font-semibold tracking-wide text-gray-900'>Support</p>
              <ul className='mt-4 space-y-3 text-sm text-gray-700'>
                <li>
                  <a className='hover:text-gray-900 transition' href='mailto:hello@voyo.fr'>
                    Centre d’aide
                  </a>
                </li>
                <li>
                  <a className='hover:text-gray-900 transition' href='mailto:hello@voyo.fr'>
                    Assistance
                  </a>
                </li>
                <li>
                  <a className='hover:text-gray-900 transition' href='/DAC7'>
                    DAC7
                  </a>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div className='lg:col-span-2'>
              <p className='text-sm font-semibold tracking-wide text-gray-900'>Légal</p>
              <ul className='mt-4 space-y-3 text-sm text-gray-700'>
                <li>
                  <a className='hover:text-gray-900 transition' href='/conditions-générales'>
                    Conditions Générales de Service (CGS)
                  </a>
                </li>
                <li>
                  <a className='hover:text-gray-900 transition' href='/cgu'>
                    Conditions Générales d&apos;Utilisation (CGU)
                  </a>
                </li>
                <li>
                  <a className='hover:text-gray-900 transition' href='/politique-confidentialite'>
                    Politique de confidentialité
                  </a>
                </li>
                <li>
                  <a
                    className='hover:text-gray-900 transition'
                    href='/politique-utilisation-cookies'
                  >
                    Politique cookies
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className='border-t border-black/10 py-8'>
          <div className='flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between'>
            <p className='text-sm text-gray-700'>
              © {new Date().getFullYear()} Voyo. Tous droits réservés.
            </p>

            <div className='flex items-center gap-3'>
              <a
                href='https://www.instagram.com/'
                target='_blank'
                rel='noopener noreferrer'
                className='group inline-flex h-10 w-10 items-center justify-center rounded-full border border-black/10 bg-white/60 text-gray-800 hover:bg-white/80 hover:border-[#f75000]/40 transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#f75000]/40 focus-visible:ring-offset-2 focus-visible:ring-offset-[#FDDFCC]'
                aria-label='Instagram'
              >
                <FaInstagram className='text-[18px] transition-colors group-hover:text-[#f75000]' />
              </a>
              <a
                href='https://www.linkedin.com/'
                target='_blank'
                rel='noopener noreferrer'
                className='group inline-flex h-10 w-10 items-center justify-center rounded-full border border-black/10 bg-white/60 text-gray-800 hover:bg-white/80 hover:border-[#f40000]/40 transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#f40000]/40 focus-visible:ring-offset-2 focus-visible:ring-offset-[#FDDFCC]'
                aria-label='LinkedIn'
              >
                <FaLinkedin className='text-[18px] transition-colors group-hover:text-[#f40000]' />
              </a>
              <a
                href='https://www.facebook.com/'
                target='_blank'
                rel='noopener noreferrer'
                className='group inline-flex h-10 w-10 items-center justify-center rounded-full border border-black/10 bg-white/60 text-gray-800 hover:bg-white/80 hover:border-[#ff9900]/50 transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#ff9900]/40 focus-visible:ring-offset-2 focus-visible:ring-offset-[#FDDFCC]'
                aria-label='Facebook'
              >
                <FaFacebook className='text-[18px] transition-colors group-hover:text-[#ff9900]' />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
